module.exports = __webpack_public_path__ + "img/7.5.COD.5fc448bd.png";